import { motion } from "framer-motion";
import { useEffect, useRef } from "react";

export function Reveal({ children, delay = 0, className = "", y = 28, ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "h1" }) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, delay: delay + i * 0.13, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function LiveBeats({ bpm = 70 }) {
  const ref = useRef(null);
  useEffect(() => {
    let beats = 0;
    const id = setInterval(() => {
      beats += 1;
      if (ref.current) ref.current.textContent = beats.toLocaleString("es-ES");
    }, 60000 / bpm);
    return () => clearInterval(id);
  }, [bpm]);
  return <span ref={ref} className="font-mono">0</span>;
}
